import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';

@Injectable({
  providedIn: 'root'
})
export class RegularizationService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  RegularizationRuleSelectUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `RegularizationRuleSelect/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  RegularizationRuleInsertUpdate(Detail: any) {
    return this.http.post<any>(environment.API_URL + `RegularizationRuleInsert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  SaveRegularizationAttendance(Detail: any) {
    return this.http.post<any>(environment.API_URL + `RegularizationAttendance/Save`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  RegularizationAttendanceDetails(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Details/RegularizationAttendance`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LoadRegularizationApprovalDetailsApp(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LoadRegularizationApprovalDetails/App`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
